import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useBasicInfoPopupStyles = makeStyles({
    basicInfoPopup: {
        '@media screen and (max-width: 480px)': {
            maxWidth: '320px',
            maxHeight: 'unset'
        }
    },
    header: {
        fontWeight: tokens.fontWeightBold,
        fontSize: tokens.fontSizeBase600
    },
    button: {
        fontSize: tokens.fontSizeBase400,
        ...shorthands.padding('0', tokens.spacingHorizontalXXXL),
        backgroundColor: 'white',
        color: 'black',
        ...shorthands.borderRadius(tokens.borderRadiusLarge),
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground4,
            color: 'black'
        },
        marginRight: tokens.spacingHorizontalL,
        width: '150px',
        height: '40px',
        '@media screen and (max-width: 480px)': {
            ...shorthands.margin('0', 'auto')
        }
    }
});
